import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-text-lg mt-2" }

import {useRouter} from "vue-router"
import {useSettingsStore} from "@/api/store/settings"
import {getCurrentAppVersion, getAvailableAppVersion, performImmediateUpdate} from "@/plugins/updater";
import {reactive, computed} from "vue";
import {useUserStore} from "@/api/store/user";
import AddressManager from "./ClientComponents/AddressManager.vue";
import FormField from "@/components/Forms/FormField.vue";
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientView',
  setup(__props) {

const settingsStore = useSettingsStore();
const userStore = useUserStore();

const router = useRouter();

const logout = () => {
  userStore.logout();
  router.push({name: "login"});
}

const state = reactive({
  appVersion: "",
  appAvailableVersion: "",
  profileForm: {
    edit: false,
  }
});

getCurrentAppVersion().then((version) => {
  state.appVersion = version;
}).catch((err) => {
  state.appVersion = "Unavailable";
  console.log(err);
});

getAvailableAppVersion().then((version) => {
  state.appAvailableVersion = version || "Unavailable";
}).catch((err) => {
  state.appAvailableVersion = "Unavailable";
  console.log(err);
});

const openUpdate = () => {
  performImmediateUpdate();
}

const buttonStyle = computed(() => {
  return "background: linear-gradient(180deg, rgba(250, 250, 250, 0.5) 5%, rgba(255, 255, 255, 1) 100%); color: " + settingsStore.settings.primaryColor + ";";
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        class: "text-center",
        color: "transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, {
            class: "text-center",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                height: "100",
                src: "/img/account_circle.png"
              }),
              _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(userStore).user.first_name + ' ' + _unref(userStore).user.last_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "d-flex justify-center pa-4 mt-5",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                color: _unref(settingsStore).settings.buttonColor2,
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'health-suite' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2 text-white",
                    icon: "fa fa-heartbeat",
                    size: "40"
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "p-text-md text-white" }, "Health Suite", -1))
                ]),
                _: 1
              }, 8, ["color"]),
              _createVNode(_component_v_sheet, {
                color: _unref(settingsStore).settings.buttonColor2,
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'notifications' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2 text-white",
                    icon: "fa fa-comment",
                    size: "40"
                  }),
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "p-text-md text-white" }, "Messages", -1))
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "d-flex justify-center pa-4",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'client-details' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2",
                    icon: "fa fa-address-card",
                    size: "40"
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "p-text-md" }, "Contact Details", -1))
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push({ name: 'medical-details' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2",
                    icon: "fa fa-id-card",
                    size: "40"
                  }),
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "p-text-md" }, "Medical Details", -1))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "d-flex justify-center pa-4",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'medical-alerts' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2",
                    icon: "fa fa-warning",
                    size: "40"
                  }),
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "p-text-md" }, "Medical Alerts", -1))
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'health-goals' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, {
                    icon: "health-goals",
                    color: _unref(settingsStore).settings.primaryColor,
                    width: "50",
                    height: "50"
                  }, null, 8, ["color"]),
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "p-text-md" }, "Health Goals", -1))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, {
            class: "d-flex justify-center pa-4",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('associated-accounts')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2",
                    icon: "fa fa-sign-out",
                    size: "40"
                  }),
                  _cache[14] || (_cache[14] = _createElementVNode("p", { class: "p-text-md" }, "Switch Account", -1))
                ]),
                _: 1
              }, 8, ["style"]),
              _createVNode(_component_v_sheet, {
                style: _normalizeStyle(buttonStyle.value),
                class: "pa-3 mx-4 b-round-20",
                elevation: "3",
                height: "100",
                width: "120",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push('logout')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "my-2",
                    icon: "fa fa-sign-out",
                    size: "40"
                  }),
                  _cache[15] || (_cache[15] = _createElementVNode("p", { class: "p-text-md" }, "Logout", -1))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})